import React from 'react';

export function SplashScreen() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
      {/* Logo */}
      <div className="w-24 h-24 md:w-32 md:h-32 rounded-3xl overflow-hidden shadow-lg">
        <img
          src="/app-icon.png"
          alt="Strokone"
          className="w-full h-full object-cover"
          loading="eager"
        />
      </div>
    </div>
  );
}
